import { Routes} from '@angular/router';
import { ErrorComponent } from './error.component';

export const appRoutes: Routes = [
  {
    path: '', component: ErrorComponent,
  },
];


